import { apiGet } from '.';
import { ServerInfo, PublicServerInfo } from '../../../shared/types/info';

export function getServerInfo(): Promise<ServerInfo> {
  return apiGet('/info');
}

export function getPublicServerInfo(): Promise<PublicServerInfo> {
  return apiGet('/public-info', {}, false);
}
